export class CodesByVendor {
    vendor: string
    code: string
    codes: number[]

    constructor(vendor: string, code: string, codes: number[]) {
        this.vendor = vendor
        this.code = code
        this.codes = codes
    }
}